import { useQuery } from '@tanstack/react-query'
import { useEffect, useMemo, useState } from 'react'
import { ProjectService } from 'src/services/project.service'
import { getMimeType } from 'src/utils/file-download.util'

const useStandalonePatientVariableDocument = (
  variableId: number | undefined,
  patientId: string | number,
  projectId: string | number,
  enabled = true,
) => {
  const { isLoading, isError, error, data, refetch } = useQuery({
    queryKey: ['standalone-patient-variable-document', variableId, patientId, projectId],
    queryFn: () =>
      ProjectService.getStandalonePatientVariableDocument(variableId as number, patientId, projectId),
    enabled: enabled && variableId !== undefined,
  })

  const [objectUrl, setObjectUrl] = useState<string>()

  useEffect(() => {
    if (!data?.data) return
    const url = URL.createObjectURL(data.data as Blob)
    setObjectUrl(url)
    return () => {
      URL.revokeObjectURL(url)
      setObjectUrl(undefined)
    }
  }, [data?.data])

  const mimeType = useMemo((): string => {
    return getMimeType(data?.headers?.['content-type'] as string | undefined)
  }, [data?.headers])

  return { isLoading, isError, error, objectUrl, mimeType, refetch }
}

export { useStandalonePatientVariableDocument }
